export const GET_ALL_ARTICLE_REQUEST = "GET_ALL_ARTICLE_REQUEST";
export const GET_ALL_ARTICLE_SUCCESS = "GET_ALL_ARTICLE_SUCCESS";
export const GET_ALL_ARTICLE_FAIL = "GET_ALL_ARTICLE_FAIL";
export const DELETE_ARTICLE_REQUEST = "DELETE_ARTICLE_REQUEST";
export const DELETE_ARTICLE_SUCCESS = "DELETE_ARTICLE_SUCCESS";
export const DELETE_ARTICLE_FAIL = "DELETE_ARTICLE_FAIL";
export const ADD_ARTICLE_REQUEST = "ADD_ARTICLE_REQUEST";
export const ADD_ARTICLE_SUCCESS = "ADD_ARTICLE_SUCCESS";
export const ADD_ARTICLE_FAIL = "ADD_ARTICLE_FAIL";
export const UPDATE_ARTICLE_REQUEST = "UPDATE_ARTICLE_REQUEST";
export const UPDATE_ARTICLE_SUCCESS = "UPDATE_ARTICLE_SUCCESS";
export const UPDATE_ARTICLE_FAIL = "UPDATE_ARTICLE_FAIL";
